module.exports = __webpack_public_path__ + "img/duc_infomation.5d05d1fe.png";